/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import { omitEmptyArgs } from 'helper';
import * as c from './constant';

export const getAssessmentLevelList = (payload, callback) =>
  req.list(
    c.GET_ASSESSMENT_LEVEL_LIST,
    'api/v1/rpt/administrator/machineries/settings/machinery_assessment_levels?isPaginate=1',
    omitEmptyArgs(payload),
    callback
  );

export const getSingleAssessmentLevel = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_ASSESSMENT_LEVEL,
    `api/v1/rpt/administrator/machineries/settings/machinery_assessment_levels/${id}`,
    payload,
    callback
  );

export const createAssessmentLevel = (payload, callback) =>
  req.create(
    c.CREATE_ASSESSMENT_LEVEL,
    'api/v1/rpt/administrator/machineries/settings/machinery_assessment_levels',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateAssessmentLevel = (id, payload, callback) =>
  req.update(
    c.UPDATE_ASSESSMENT_LEVEL,
    `api/v1/rpt/administrator/machineries/settings/machinery_assessment_levels/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeAssessmentLevel = (id, payload, callback) =>
  req.remove(
    c.REMOVE_ASSESSMENT_LEVEL,
    `api/v1/rpt/administrator/machineries/settings/machinery_assessment_levels/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS_LIST,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );
